import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connectAsync } from 'iguazu';
import { queryModuleWithData } from 'iguazu-holocron';
import { queryLanguagePack } from '@americanexpress/one-app-ducks';
import {
  getLogoutUrl, getWindowRef, isInIframe, postMessage,
} from '../utility';
import {
  AMEX_URL,
  CLOSE_SESSION_FRAME,
  // CLOSE_SESSION_FRAME,
  HELP_URL, MODULE_NAME, STATUS_CANCEL, TASK_FLOW_TITLE,
} from '../constants';
import TaskFlowLayout from './TaskFlowLayout';

const SmartWrapper = ({
  children,
  languageData,
  loadStatus,
  PageWrapper,
  TaskFlowWrapper,
  route,
}) => {
  const simplifiedWrapperProps = {
    headerProps: {
      minimisedHeader: true,
      exitApplication: getLogoutUrl(),
      exitAppLabel: 'Close',
    },
    footerProps: {
      hideChangeCountrySection: true,
      hideLogoSection: true,
      hideSocialSection: true,
      children: null,
    },
  };

  const isUsWrapperUplifted = languageData?.useOneAuthV3Uplift;
  const marketBasedAxpPageWrapperProps = isUsWrapperUplifted ? simplifiedWrapperProps : {};
  const marketBasedModule = isUsWrapperUplifted ? 'identity-ui-task-flow-wrapper' : 'axp-page-wrapper';

  const taskFlowAnalytics = {
    modalCloseButton: { element: 'modal_close' },
  };

  const onClose = () => {
    const win = getWindowRef();
    if (!win) return;

    if (isInIframe(win)) {
      if (typeof win.top?.postMessage === 'function') {
        postMessage(CLOSE_SESSION_FRAME, { status: STATUS_CANCEL });
        postMessage(CLOSE_SESSION_FRAME, STATUS_CANCEL, '*');
      }
      return;
    }

    if (win.history?.length > 1 && typeof win.history.back === 'function') {
      win.history.back();
      return;
    }

    if (typeof win.history?.go === 'function') {
      win.history.go(-1);
    }
  };

  const locale = languageData?.locale?.toLowerCase();

  const helpUrl = `${AMEX_URL}/${locale}/${HELP_URL}`;

  const marketBasedTaskFlowWrapperProps = isUsWrapperUplifted
    ? {
      analyttics: taskFlowAnalytics,
      title: TASK_FLOW_TITLE,
      containerClassName: 'flex',
      onClose,
      consumerHelpUrl: helpUrl,
      shouldRedirectOnClose: false,
    }
    : {};

  const { wrapperType } = route || {};

  if (loadStatus.all === 'loading') {
    return null;
  }

  if (wrapperType === 'task-flow') {
    if (marketBasedModule === 'identity-ui-task-flow-wrapper') {
      return (
        <TaskFlowWrapper {...marketBasedTaskFlowWrapperProps}>
          <TaskFlowLayout>{children}</TaskFlowLayout>
        </TaskFlowWrapper>
      );
    }

    return <PageWrapper {...marketBasedAxpPageWrapperProps}>{children}</PageWrapper>;
  }

  return <PageWrapper {...marketBasedAxpPageWrapperProps}>{children}</PageWrapper>;
};

SmartWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  languageData: PropTypes.shape({
    taskFlowTitle: PropTypes.string,
    useOneAuthV3Uplift: PropTypes.bool,
    locale: PropTypes.string,
  }),
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }).isRequired,
  PageWrapper: PropTypes.func.isRequired,
  TaskFlowWrapper: PropTypes.func.isRequired,
  route: PropTypes.shape({
    wrapperType: PropTypes.oneOf(['simplified', 'task-flow']),
  }).isRequired,
};

SmartWrapper.defaultProps = {
  languageData: undefined,
};

export const loadDataAsProps = ({ store: { dispatch } }) => ({
  PageWrapper: () => dispatch(queryModuleWithData('axp-page-wrapper')),
  TaskFlowWrapper: () => dispatch(queryModuleWithData('identity-ui-task-flow-wrapper')),
  Header: () => dispatch(queryModuleWithData('axp-global-header')),
  Footer: () => dispatch(queryModuleWithData('axp-footer')),
  headerLang: () => dispatch(queryLanguagePack('axp-global-header')),
  footerLang: () => dispatch(queryLanguagePack('axp-footer')),
});

export { SmartWrapper as ComponentUnderTest };

const hocChain = compose(
  oneAppModuleWrapper(MODULE_NAME),
  connectAsync({ loadDataAsProps })
);

export default hocChain(SmartWrapper);
